import type { IMetaDataFormHook } from '../../../app/electoral-divisions/polling-unit/utils';
import type {
	IGetByPollingUnitCode,
	IPollingUnitByIDState,
	IPollingUnitInWardsStates,
} from '../../../interface/state/IPollingUnitState';
import { poolingUnitType } from '../../types';
import { getCoreQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

export const create_PoolingUnit = ({
	onFailure,
	onSuccess,
	data,
}: IResponse & {
	data: IPollingUnitCreateUpdate;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/PoolingUnit',
			header: utils.header(),
			data,
		},
		actionType: poolingUnitType.create_PoolingUnit,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnit = ({ onFailure, onSuccess, query, paged }: IGetQuery) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/PoolingUnit${getCoreQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: poolingUnitType.get_PoolingUnit,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnitByID = ({ onFailure, onSuccess, id }: IResponse<IPollingUnitByIDState> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/PoolingUnit/${id}`,
			header: utils.header(),
		},
		actionType: poolingUnitType.get_PoolingUnitByID,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnitByName = ({ onFailure, onSuccess, name }: IResponse & { name: string }) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/PoolingUnit/name',
			header: utils.header(),
			data: { name },
		},
		actionType: poolingUnitType.get_PoolingUnitByName,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnitByCode = ({
	onFailure,
	onSuccess,
	poolingUnitCode,
}: IResponse<IGetByPollingUnitCode> & { poolingUnitCode: string }) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/PoolingUnit/code',
			header: utils.header(),
			data: { poolingUnitCode },
		},
		actionType: poolingUnitType.get_PoolingUnitByCode,
		onFailure,
		onSuccess,
	});

export interface IPollingUnitCreateUpdate {
	id?: number;
	poolingUnitCode: string;
	name: string;
	description: string;
	wardId: number;
	latitude: string;
	longitude: string;
	location: string;
}

export const update_PoolingUnit = ({
	onFailure,
	onSuccess,
	data,
}: IResponse & {
	data: IPollingUnitCreateUpdate;
}) =>
	utils.httpPutMethod({
		apiData: {
			url: '/api/v1/PoolingUnit/update',
			header: utils.header(),
			data,
		},
		actionType: poolingUnitType.update_PoolingUnit,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnitPresidingOfficer = ({
	onFailure,
	onSuccess,
	poolingUnitID,
	presidingOfficerId,
}: IResponse & {
	presidingOfficerId: number;
	poolingUnitID: number;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: `/api/v1/PoolingUnit/PresidingOfficer?presidingOfficerId=${presidingOfficerId}&poolingUnitID=${poolingUnitID}`,
			header: utils.header(),
		},
		actionType: poolingUnitType.get_PoolingUnitPresidingOfficer,
		onFailure,
		onSuccess,
	});

export const get_PoolingUnitInWard = ({
	onFailure,
	onSuccess,
	data,
	params,
	pageNumber,
	pageSize,
}: IResponse<IPollingUnitInWardsStates> & {
	data: {
		wardIds: number[];
	};
	params?: string;
	pageSize?: number;
	pageNumber?: number;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: `/api/v1/PoolingUnit/getPollingUnitsInWard${params}`,
			header: utils.header(),
			data: {
				...data,
				pageNumber,
				pageSize,
			},
		},
		actionType: poolingUnitType.get_PoolingUnitInWard,
		onFailure,
		onSuccess,
	});

export const delete_PoolingUnit = ({
	onFailure,
	onSuccess,
	id,
}: IResponse & {
	id: string;
}) =>
	utils.httpDeleteMethod({
		apiData: {
			url: `/api/v1/PoolingUnit/delete/${id}`,
			header: utils.header(),
		},
		actionType: poolingUnitType.delete_PoolingUnit,
		onFailure,
		onSuccess,
	});

export const updateMetaData_PoolingUnit = ({
	onFailure,
	onSuccess,
	id,
	data,
}: IResponse & {
	id: number;
	data: IMetaDataFormHook;
}) =>
	utils.httpPutMethod({
		apiData: {
			url: `/api/v1/PollingUnit/updatemetadata/${id}`,
			header: utils.header(),
			data,
		},
		actionType: poolingUnitType.updateMetaData_PoolingUnit,
		onSuccess,
		onFailure,
	});
